import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ExamBlockPlaceHolder } from '../../Constant/api';
export const ExamBlock = ({ item, examSlug }) => {
  const location = useLocation();
  return (
    <div style={{
      padding: "5px", margin: "5px 0px", border: "1.5px solid #bbb",
      borderRadius: "5px",
    }}>
      {item.meta.featured_image !== "" ?
        <img className="col-12" src={item.meta.featured_image}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
        :
        <img className="col-12"
          src={ExamBlockPlaceHolder}
          style={{ objectFit: 'contain', height: "100px", borderRadius: "3px" }} />
      }
      <br />
      <div>
        {item.title.rendered}&nbsp;
      </div>
      {(!JSON.stringify(location).includes("all-demo-exam-list") && item.meta.exam_question_block_student == undefined) ?
        <div style={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
          <div className="sign-in-button-1 col-8 Link" style={{ color: "#fff", opacity: 0.5 }}
          >
            Verify to Start
          </div>
        </div>
        :
        <div style={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
          {item.meta.available_unavailable == "Available" ?
            <Link className="sign-in-button-1 col-8"
              to={`${examSlug}/${item.slug}`}
            >
              Start Exam
            </Link>
            :
            <div className="sign-in-button-1 col-8 Link" style={{ color: "#000", backgroundColor: "#fff" }}>
              Exam Unavailable
            </div>
          }
        </div>
      }
    </div >
  )

}